import Effects from "./Effects";
import Text from "./Text";

const SectionHeading = ({
  children,
  id,
  animate = false,
  subtitle,
  viewMore,
  className = "",
}) => (
  <div className={`mb-10 ${className}`}>
    <div className="flex items-center justify-between gap-6 max-w-screen flex-wrap">
      <Text
        is="h2"
        variant="section-heading"
        id={id}
        className="homepage-section-heading text-gray-900 whitespace-nowrap !mb-0 !pb-0"
      >
        {animate ? (
          <Effects type="letter-fadeup">{children}</Effects>
        ) : (
          children
        )}
      </Text>
      <div className="flex-1 h-px bg-gray-200 self-center" />
      {viewMore && (
        <Text
          is="a"
          href={viewMore}
          className="whitespace-nowrap text-sm font-medium text-blue-500 hover:text-blue-700 transition-colors flex-shrink-0 ml-auto"
        >
          View More →
        </Text>
      )}
    </div>
    {subtitle && (
      <Text
        is="p"
        variant="body"
        className="text-gray-500 mt-0.5 text-sm"
        style={{ paddingLeft: "1.25rem" }}
      >
        {subtitle}
      </Text>
    )}
  </div>
);

export default SectionHeading;
